import { render, staticRenderFns } from "./BudgetReportItem.vue?vue&type=template&id=2a50e7c6&scoped=true"
import script from "./BudgetReportItem.vue?vue&type=script&lang=js"
export * from "./BudgetReportItem.vue?vue&type=script&lang=js"
import style0 from "./BudgetReportItem.vue?vue&type=style&index=0&id=2a50e7c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a50e7c6",
  null
  
)

export default component.exports